import React from "react";

export type FieldEntry = {
  label: string;
  value?: string | null;
};

type PreviewFieldColumnProps = {
  fields: FieldEntry[];
};

// Label/value rows used in gatepass preview sections.
const PreviewFieldColumn: React.FC<PreviewFieldColumnProps> = ({ fields }) => {
  const normalized = fields.map(({ label, value }) => ({ label, value: value ?? "-" }));

  return (
    <div className="flex flex-col">
      {normalized.map(({ label, value }, index) => (
        <div
          key={`${label}-${index}`}
          className={`flex items-center py-3 ${index < normalized.length - 1 ? "border-b border-gray-100" : ""}`}
        >
          <span className="w-1/2 text-sm font-normal text-gray-500">{label}</span>
          <span className="w-1/2 text-sm font-medium text-gray-900 break-words break-all">
            {value}
          </span>
        </div>
      ))}
    </div>
  );
};

export default PreviewFieldColumn;
